/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { withCustomValidation } from '@bingads-webui-react/validation';
import { ActivityContext } from '@bingads-webui-react/hoc-with-signal';
import { AutoGeneratedAssetsImpl } from './auto-generated-assets-impl';

const AutoGeneratedAssets = ({ validationProps, updateValidation }) => {
  const activity = useContext(ActivityContext);
  const i18n = useContext(I18nContext);
  const { data: { finalUrlExpansions, options } } = validationProps;
  const onChange = useCallback((newData) => {
    updateValidation([], newData);
    if (activity) {
      activity.signal(`onAutoGeneratedAssetsChange - ${JSON.stringify(newData)}`);
    }
  }, [updateValidation]);

  return (
    <AutoGeneratedAssetsImpl
      i18n={i18n}
      finalUrlExpansions={finalUrlExpansions}
      options={options}
      onChange={onChange}
    />
  );
};

AutoGeneratedAssets.propTypes = {
  validationProps: PropTypes.shape({
    data: PropTypes.shape({
      finalUrlExpansions: PropTypes.arrayOf(PropTypes.shape({})),
      options: PropTypes.shape({
        autoGeneratedTextOptOut: PropTypes.bool,
        autoGeneratedImageOptOut: PropTypes.bool,
        finalUrlExpansionOptOut: PropTypes.bool,
      }),
    }),
  }).isRequired,
  updateValidation: PropTypes.func.isRequired,
};

export const ValidatedAutoGeneratedAssets = withCustomValidation(AutoGeneratedAssets);
